import { render, staticRenderFns } from "./delete-acct-btn.vue?vue&type=template&id=4ccf1e84&"
import script from "./delete-acct-btn.vue?vue&type=script&lang=js&"
export * from "./delete-acct-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports